import { Controller } from "stimulus";

// Marks the Join / Go To Event click so /watch can prefer unmuted playback.
export default class extends Controller {
  preferSound(event) {
    try {
      sessionStorage.setItem("jll_want_sound", "1");
    } catch (e) {
      /* private mode / blocked storage */
    }

    // Optional: append ?sound=1 for redirects that drop sessionStorage (rare).
    const el = event && event.currentTarget;
    if (!el || el.tagName !== "A") return;
    try {
      const url = new URL(el.href, window.location.origin);
      if (!url.searchParams.has("sound")) {
        url.searchParams.set("sound", "1");
        el.href = url.toString();
      }
    } catch (e) {
      /* ignore malformed href */
    }
  }
}
